import { userSlice, companySlice } from "./mosaic";

const store = {
  companySlice,
  userSlice,
};

export default store;
